import { Box } from "@mui/material";
import { Fragment, useContext, useEffect, useState } from "react";
import { LanguageContext } from "../../../../context/LanguageContext";
import { ParagraphText, UBButton, UBOTPInput } from "../../../../Libraries";
import { HeaderRupin } from "../../../common";
import { ArrowIcon, PhoneIcon, SMSIcon, Whatsapp } from "../../../../assets/icons/icon";
import { sendOTP, Sync } from "../../../../SyncService";
import { useSnackbar } from "../../../../context/SnackbarContext";
import Cookies from "js-cookie";
import { useAuthContext } from "../../../../context/AuthContext";
import BusinessLoader from "../../../common/BusinessLoader";
import { useNavigate } from "react-router-dom";
import { analytics, triggerLogEvent } from "../../../../config/firebase";
import { handleApi } from "../../../../apis";
import { POST_CAPTCHA, POST_LOGIN } from "../../../../apis/configuration";
import FooterRupin from "../../../common/FooterRupin";
import styles from "./../styles.module.css";
import { PUT_CAPTCHA } from "../../../../apis/configuration";
import { sentenceCase } from "../../../../constants";
const VerifyOTP = ({
  phone,
  handleVerifyOTP,
  sendOTPResponse,
  documentId,
  reCaptcha,
  setDocumentId
}) => {
  const navigate = useNavigate();
  const [I18n] = useContext(LanguageContext);
  const { showSnackbar } = useSnackbar();
  const { user, setUser } = useAuthContext();
  const [loading, setLoading] = useState(false);
  const [OTPVerifyloading, setOTPVerifyLoading] = useState(false);
  const OTPOPTION = {
    voice: { name: "voice", icon: <PhoneIcon />, label: I18n.phone_number },
    sms: { name: "sms", icon: <SMSIcon />, label: I18n.phone_sms },
    whatsapp: {
      name: "whatsapp",
      icon: <Whatsapp width={16} height={16} />,
      label: I18n.whatsapp_number,
    },
  };
  const [value, setValue] = useState("");
  const [seconds, setSeconds] = useState(30); // Initialize countdown at 30 seconds
  const [isHideOTPSentBtn, setIsHideOTPSentBtn] = useState(true);
  const [otpOption, setOtpOption] = useState(
    OTPOPTION[
      sendOTPResponse?.otp_channel === "call"
        ? "voice"
        : sendOTPResponse?.otp_channel
    ]?.name,
  );
  const [error, setError] = useState("");

  useEffect(() => {
    if (seconds > 0) {
      const interval = setInterval(() => {
        setSeconds((prevSeconds) => prevSeconds - 1);
      }, 1000); // Update every second

      return () => clearInterval(interval); // Clear interval when component unmounts or timer reaches 0
    } else {
      setIsHideOTPSentBtn(false); // Enable button again once timer finishes
    }
  }, [seconds]);

  const resendOTP = async (option) => {
    setLoading(true);
    setValue("");
    try {
      const payload = {
        "payment_process": "pin_reset",
        phone_number: phone,
        document_id: documentId,
        "g-recaptcha-response": reCaptcha,
        otp_channel: option !== OTPOPTION.whatsapp.name ? option : undefined,
      }
      const responsePUT = await handleApi(POST_CAPTCHA, payload, null, navigate);
      setDocumentId(responsePUT?.document_id)
      setOtpOption(option);
      triggerLogEvent(
        analytics,
        `forgot_otp_resend_${option == "voice" ? "call" : option}`,
      );
      setSeconds(30); // Reset the countdown to 30 seconds
      setIsHideOTPSentBtn(true); // Disable the button until the timer is finished
      setValue("");
      setLoading(false);
      setError("");
    } catch (error) {
      if (error?.response?.data?.message)
        setError(error?.response?.data?.message);
      setSeconds(0); // Reset the countdown to 30 seconds
      setIsHideOTPSentBtn(false); // Disable the button until the timer is finished
      setValue("");
      setLoading(false);
    }
  };

  const submitVerifyOTP = async (otp) => {
    setValue(otp);
    if (value.length == 0 && otp.length >= 1)
      triggerLogEvent(analytics, "forgot_otp_enter");
    if (otp.length === 4) {
      try {
        setError("");
        setOTPVerifyLoading(true);
        const response = await handleApi(
          PUT_CAPTCHA,
          { "payment_process": "pin_reset", "phone_number": phone, "document_id": documentId, otp: otp },
          null,
          navigate,
        );
        if (response?.otp_expired || !response?.verified) {
          setOTPVerifyLoading(false);
          setError(response?.message);
          setValue("");
          setSeconds(0); // Reset the countdown to 30 seconds
          setIsHideOTPSentBtn(false); // Disable the button until the timer is finished
          return;
        }
        if (response?.verified) {
          setOTPVerifyLoading(false);
          handleVerifyOTP(response);
          showSnackbar({
            message: I18n.otp_verified_successfully,
            severity: "success",
            icon: "",
            toastId: "verifyOTPSuccess",
          });
          triggerLogEvent(analytics, "forgot_otp_verified");
        }
      } catch (error) {
        setOTPVerifyLoading(false);
        setError(error.response.data.message || "Error in OTP verify");
        setValue("");
        setSeconds(0); // Reset the countdown to 30 seconds
        setIsHideOTPSentBtn(false); // Disable the button until the timer is finished
      }
    }
  };

  const resendOTPOptions = sendOTPResponse?.resend_otp_options || [];

  return (
    <Box className={`${styles.verifyOTPWrapper} onBoardingScreenWrapper`}>
      <BusinessLoader loadBusiness={OTPVerifyloading || loading} />
      {!OTPVerifyloading && !loading && (
        <Fragment>
          <HeaderRupin />
          <Box
            display={"flex"}
            alignItems={"center"}
            justifyContent={"center"}
            flexDirection={"column"}
            height={"calc(100% - 72px)"}
          >
            <Box className={styles.verifyOTPInner}>
              <ParagraphText className={"fontSize24 fontWeight500 newFontColor"}>
                {sentenceCase(`${I18n.verify} ${I18n.phone_number}`)}
              </ParagraphText>
              <Box mb={"10px"} />
              <ParagraphText className={`fontSize14 newLightColor ${styles.optionStyle}`}>
                <Box display={"flex"} alignItems={"center"} gap={1}>
                  {otpOption === OTPOPTION.voice.name
                    ? I18n.we_will_call_for_OTP_to_your
                    : I18n.otp_code_sent}{" "}
                  {OTPOPTION[otpOption]?.icon} {OTPOPTION[otpOption].label}
                </Box>
                {phone || ""}
              </ParagraphText>
              <Box marginBottom={2} />
              <UBOTPInput
                label={I18n.enter_otp_code}
                id="verify_otp"
                className="marginTop40"
                placeholder="****"
                value={value}
                onChangeQuery={submitVerifyOTP}
                shouldAutoFocus={true}
                invalid={!!error}
                helperText={error}
              />
              <Box marginBottom={"34px"} />
              {isHideOTPSentBtn ? (
                <Box display={"flex"} alignItems={"center"} gap={1}>
                  <ParagraphText className={"fontSize14  newLightColor"}>
                    {I18n.resend_code_in} <span className="marginLeft5">{`00:${String(seconds).padStart(2, "0")}`}</span>
                  </ParagraphText>
                </Box>
              ) : (
                <Box>
                  <ParagraphText className={"fontSize14 newFontColor"}>
                    {I18n.Select_the_options_below_to_receive_a_new_OTP}
                  </ParagraphText>
                  <Box className={styles.VerifyOTPResetBtn}>
                    {resendOTPOptions.includes("sms") && (
                      <UBButton
                        id="opt_sms_btn"
                        disabled={loading}
                        iconComponent={<SMSIcon />}
                        className="ubSecondaryButton"
                        title={I18n.sms}
                        loading={otpOption === OTPOPTION.sms.name && loading}
                        onClick={() => resendOTP(OTPOPTION.sms.name)}
                      />
                    )}
                    {resendOTPOptions.includes("call") && (
                      <UBButton
                        id="opt_call_btn"
                        disabled={loading}
                        iconComponent={<PhoneIcon width={18} height={18}/>}
                        className="ubSecondaryButton"
                        title={I18n.call}
                        loading={otpOption === OTPOPTION.voice.name && loading}
                        onClick={() => resendOTP(OTPOPTION.voice.name)}
                      />
                    )}
                    {resendOTPOptions.includes("whatsapp") && (
                      <UBButton
                        id="opt_whatsapp_btn"
                        disabled={loading}
                        iconComponent={<Whatsapp />}
                        className="ubSecondaryButton"
                        title={I18n.whatsapp}
                        loading={otpOption === OTPOPTION.whatsapp.name && loading}
                        onClick={() => resendOTP(OTPOPTION.whatsapp.name)}
                      />
                    )}
                  </Box>
                </Box>
              )}
            </Box>
          </Box>
          <FooterRupin />
        </Fragment>
      )}
    </Box>
  );
};
export default VerifyOTP;
